'use client';

import { c as _c } from "react/compiler-runtime";
import QueryProvider from '@/components/providers/QueryProvider';
import I18nProvider from '@/components/providers/I18nProvider';
import { ToastProvider } from '@/hooks/use-toast';
import { UserSettingsProvider } from '@/contexts/UserSettingsContext';
import { SuperAdminTenantProvider } from '@/contexts/SuperAdminTenantContext';
import SessionRestoreProvider from '@/components/auth/SessionRestoreProvider';
import { SessionKeeper } from '@/components/auth/SessionKeeper';
import { TourProvider } from '@/contexts/TourContext';
import { ErrorBoundary } from '@/components/ui/error-boundary';

/** Client-only provider tree for root layout (keeps layout.tsx as a server component). */
export default function AppProviders(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SessionKeeper />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <QueryProvider><SessionRestoreProvider><UserSettingsProvider><I18nProvider><ToastProvider><SuperAdminTenantProvider><TourProvider><ErrorBoundary>{t1}{children}</ErrorBoundary></TourProvider></SuperAdminTenantProvider></ToastProvider></I18nProvider></UserSettingsProvider></SessionRestoreProvider></QueryProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}